$(() => {
  const originalLength = 10; // Rows to be shown + 1 (header row)
  const table = $(".bs-section--product-features table");
  const buttonTrigger = $('.bs-section--product-features .bs-pro-button a');
  const slider = $('.bs-section--product-features .slick-slider.bs-slider-content');

  table.each((i,element) => {
      const initialRows = $(element).find('tr');
      const readMoreWrapper = $(element).closest(".slick-slide-wrapper").find(".bs-div");
      initialRows.slice(0, originalLength).addClass('tr-active');
      if(originalLength > initialRows.length) {
        console.log('true');
        $(readMoreWrapper).hide();
      }
  });

  const sliderAdaptiveHeight = () => {
    var heights = [];
    let items = $('.slick-active')
    items.each(function() {
        heights.push($(this).height());
    });
    $(slider).find('.slick-list').height(Math.max.apply(null, heights));
  }

  buttonTrigger.each((i,element) => {
    let hidden = true;
    $(element).on('click', function(e) {
      const closetTable = $(this).closest(".slick-slide-wrapper").find("table");
      const closetTableRowCount = $(closetTable).find("tr").length;
      e.preventDefault();
      if (hidden) {
        $(closetTable).find('tr:lt(' + closetTableRowCount + ')').hide();
        $(closetTable).find('tr:lt(' + closetTableRowCount + ')').show();
        $(this).addClass('show-less');
        $(this).html('Show less');
        sliderAdaptiveHeight();
      } else {
        $(closetTable).find('tr:lt(' + closetTableRowCount + ')').hide();
        $(closetTable).find('tr:lt(' + (originalLength) + ')').show();
        $(this).removeClass('show-less');
        $(this).html('Show more features');
        sliderAdaptiveHeight();
      }
      hidden = !hidden;
    });
  });
});